export default __webpack_public_path__ + "notebook.a08279f3a77fd229.svg";